import { ChangeDetectorRef } from '@angular/core';
import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation, Renderer2, ElementRef, HostListener} from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl, ValidatorFn, AbstractControl, ValidationErrors} from '@angular/forms';
import { map, pairwise, startWith } from 'rxjs/internal/operators';
import { GeneralService } from '../../../services/general/general.service';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

import moment from 'moment';

import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import { NgxMaterialTimepickerTheme } from 'ngx-material-timepicker';
import { ActivatedRoute } from '@angular/router';

// Calendar
import { CalendarOptions, FullCalendarComponent } from '@fullcalendar/angular'; // useful for typechecking
import esLocale from '@fullcalendar/core/locales/es';
import enLocale from '@fullcalendar/core/locales/en-gb';
import ruLocale from '@fullcalendar/core/locales/ru';
import { BooleanInput } from '@angular/cdk/coercion';
import { DateTime } from 'luxon';
import { TeacherImageAdvicesDialogComponent } from 'src/app/components/teacher-image-advices-dialog/teacher-image-advices-dialog.component';
import { MatDialog,  MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/components/confirm-dialog/confirm-dialog.component';
import { BooleanLiteral } from 'typescript';

@Component({
  selector: 'app-register-teacher',
  templateUrl: './register-teacher.component.html',
  styleUrls: ['./register-teacher.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})

export class RegisterTeacherComponent implements OnInit, OnDestroy {

  @ViewChild('calendar') calendarComponent: FullCalendarComponent | undefined;
  @ViewChild('menu')
  menu!: ElementRef;

  public showCompleteRegister: boolean = false;
  public profile_completed: any;

  public user: any;
  public userInfo: any;

  public isTeacher: any;
  public isMobile: Boolean;
  public form2: FormGroup;
  public form3: FormGroup;
  public form4: FormGroup;
  public loading: any;
  public languages: any;
  public other_activities: any = [];
  public subjects: any;
  public countries: any;
  public cities: any;
  public countryFilteredOptions: any;
  public languageLevels: any;
  public subjectLevels: any;
  public subscriptions: any;
  public genders: any;
  public currentStep: number;
  public lead: any;
  public wordiixTheme: NgxMaterialTimepickerTheme = {
    container: {
      bodyBackgroundColor: 'var(--primary-color)',
      buttonColor: '#fff',
    },
    dial: {
      dialBackgroundColor: 'var(--primary-darker-color)',
    },
    clockFace: {
      clockFaceBackgroundColor: 'var(--primary-darker-color)',
      clockHandColor: 'var(--accent-color)',
      clockFaceTimeInactiveColor: '#fff',
      clockFaceInnerTimeInactiveColor: '#dfdfdf',
    },
  };

  public timeZone: any;
  //last post sended es 1, porque ya se envió el pre-registro previamente
  public lastPostSended: Number = 1;

  // Calendar
  public calendarOptions: CalendarOptions = {};
  public lastEventClicked: any = null;
  private unlistener: () => void;
  private unlistener2: () => void;

  constructor(
    private formBuilder: FormBuilder,
    public general: GeneralService,
    private route: ActivatedRoute,
    private renderer: Renderer2,
    private cdRef: ChangeDetectorRef,
    private dialog: MatDialog
  ) {

    // Calendar On click in
    this.unlistener = this.renderer.listen('window', 'click', (e: Event) => {
      setTimeout(() => {
        // this.menu.nativeElement.style.display = 'none';
      }, 50);
    });

    this.unlistener2 = this.renderer.listen('window', 'resize', (e: Event) => {
      // this.menu.nativeElement.style.display = 'none';
    });

    this.timeZone = this.general.getCurrentTimezone();

    this.isMobile = this.general.isMobile();
    this.loading = false;
    this.languages = [];
    this.subjects = [];
    this.countries = [];
    this.cities = [];
    this.languageLevels = [];
    this.subjectLevels = [];
    this.subscriptions = [];
    this.genders = ['man', 'woman'];
    this.currentStep = 0;
    this.lead = null;

    // Step 2
    this.form2 = this.formBuilder.group(
      {
        birthday: ['', [Validators.required]],
        phone: ['', [Validators.required, Validators.pattern('[- +()0-9]+')]],
        gender: ['', [Validators.required]],
        country: ['', [Validators.required]],
        city: ['', [Validators.required]],
        languages: this.formBuilder.array([
          this.formBuilder.group({
            language_id: ['', [Validators.required]],
            level_id: ['', [Validators.required]],
          }),
        ]),
        photo: ['', [Validators.required]],
        dni: ['', [Validators.required]],
        dni_front: ['', [Validators.required]],
      },
      { validators: this.validateCountryAndCity() }
    );

    // Step 3
    this.form3 = this.formBuilder.group(
      {
        description: ['', [Validators.required]],
        goal_joining: ['', [Validators.required]],
        educational_level: ['', [Validators.required]],
        dedication_time: ['', [Validators.required]],
        other_goal_joining: ['', []],
        scheedule_days: ['', []],
        scheedule: this.formBuilder.array([]),
      },
      { validators: [this.validateForm3Scheedule] }
    );

    // Step 4
    this.form4 = this.formBuilder.group({
      subjects: this.formBuilder.array([
        this.formBuilder.group(
          {
            study_lesson: [''],
            lesson_level_id: [[]],
            name: [''],
            price_hour_single: [''],
          },
          { validators: [this.validateFormSubjects] }
        ),
      ]),
      languages: this.formBuilder.array([
        this.formBuilder.group(
          {
            study_lesson: [''],
            lesson_level_id: [[]],
            name: [''],
            price_hour_single: [''],
          },
          { validators: [this.validateFormSubjects] }
        ),
      ]),
      other_activities: this.formBuilder.array([
        this.formBuilder.group(
          {
            study_lesson: [''],
            name: [''],
            price_hour_single: [''],
          },
          { validators: [this.validateFormSubjects] }
        ),
      ]),
      certificates: this.formBuilder.array([
        this.formBuilder.group(
          {
            type: ['', [Validators.required]],
            issued_by: ['', [Validators.required]],
            study_years: ['', [Validators.required]],
            document_base64: ['', [Validators.required]],
            document: ['', [Validators.required]],
            id_image: [general.getRandomId(5)],
          },
          {
            validators: this.validateStudyYears(),
          }
        ),
      ]),
    });

    this.calendarOptions = {
      height: 1180,
      initialView: 'timeGridWeek',
      allDaySlot: false,
      slotLabelFormat: {
        hour: '2-digit',
        minute: this.isMobile ? undefined : '2-digit',
        omitZeroMinute: false,
        meridiem: false,
        hour12: false,
      },
      eventMinHeight: 30,
      dayHeaderFormat: {
        weekday: this.isMobile ? 'narrow' : 'short',
      },
      locales: [esLocale, enLocale, ruLocale],
      locale:
        this.general.translate.currentLang === 'en'
          ? 'en-gb'
          : this.general.translate.currentLang,
      firstDay: 1,
      headerToolbar: false,
      editable: true,
      events: [],
      dateClick: this.handleDateClick.bind(this), // bind is important!
      eventClick: this.handleEventClick.bind(this),
      eventAllow: this.handleAllowEventSize.bind(this),
      eventLongPressDelay: 300,
      eventOverlap: false,
    };
  }

  async ngOnInit() {

    let token = localStorage.getItem('access_token');

    if (typeof token === 'string') {

      await this.getUserInfo();
      this.profile_completed = this.userInfo.profile_completed;

      if (this.user && this.user.rol == 'teacher' && this.profile_completed) {
        this.showCompleteRegister = true;
      }

      await this.general.showSuccess('must_complete_register');
    }

    document.addEventListener('set-lang', this);

    let params = this.general.getQueryParams();

    const requests = [
      this.general.httpGet('study-lessons'),
      this.general.httpGet('countries'),
      this.general.httpGet('lessons-levels'),
    ];
    const response: any = await this.general.forkJoin(requests);
    this.languages = response[0].data.filter(
      (subject: any) => subject.type === 'language'
    );
    this.subjects = response[0].data.filter(
      (subject: any) => subject.type === 'subject'
    );
    this.other_activities = response[0].data.filter(
      (subject: any) => subject.type === 'other'
    );
    this.countries = response[1].data;
    this.subjectLevels = response[2].data.filter(
      (subject: any) => subject.type === 'subject'
    );
    this.languageLevels = response[2].data.filter(
      (subject: any) => subject.type === 'language'
    );

    this.intializeSubscriptions();
  }

  async getUserInfo() {
    const response = await this.general.getUserInfo();
    this.userInfo = response.data;
    this.user = this.userInfo.user;
  }

  async reload() {
    const requests = [
      this.general.httpGet('study-lessons'),
      this.general.httpGet('countries'),
      this.general.httpGet('lessons-levels'),
    ];
    const response: any = await this.general.forkJoin(requests);
    this.languages = response[0].data.filter(
      (subject: any) => subject.type === 'language'
    );
    this.other_activities = response[0].data.filter(
      (subject: any) => subject.type === 'other'
    );
    this.subjects = response[0].data.filter(
      (subject: any) => subject.type === 'subject'
    );
    this.countries = response[1].data;
    this.subjectLevels = response[2].data.filter(
      (subject: any) => subject.type === 'subject'
    );
    this.languageLevels = response[2].data.filter(
      (subject: any) => subject.type === 'language'
    );
  }

  ngOnDestroy() {
    document.removeEventListener('set-lang', this);

    this.unlistener();
    this.unlistener2();

    this.subscriptions.forEach((subscription: any) => {
      subscription.unsubscribe();
    });
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  /**
   * Triggered when stepper change current index
   * @param event
   */
  onChangeStep(event: any) {
    switch (event.previouslySelectedIndex) {
      case 1:
        this.form2.markAllAsTouched();
        break;
      case 2:
        this.form3.markAllAsTouched();
        break;
      case 3:
        this.form4.markAllAsTouched();
        break;
    }
  }

  /**
   * =================== Calendar ===================
   */
  // Handle event Listener
  async handleEvent(event: any) {
    switch (event.type) {
      case 'set-lang':
        this.calendarOptions.locale =
          event.detail === 'en' ? 'en-gb' : event.detail;
        await this.reload();
        break;
    }
  }

  handleDateClick(args: any) {
    let calendarApi = this.calendarComponent?.getApi();

    const dateStart = DateTime.fromISO(args.dateStr, {
      zone: this.timeZone,
    });
    let dateEnd = DateTime.fromISO(args.dateStr, {
      zone: this.timeZone,
    });

    if (dateStart.get('hour') === 23 && dateStart.get('minute') === 30) {
      return;
    }

    if (dateStart.get('hour') + 1 === 24) {
      dateEnd = dateEnd.plus({ minute: 59 });
    } else {
      dateEnd = dateEnd.plus({ hour: 1 });
    }

    // Check if already exist an event between dates
    const events: any = calendarApi?.getEvents();
    const exit = events.find((event: any) => {
      const currentEventStart = DateTime.fromISO(event.startStr, {
        zone: this.timeZone,
      });
      const currentEventEnd = DateTime.fromISO(event.endStr, {
        zone: this.timeZone,
      });

      if (
        (dateStart.toMillis() >= currentEventStart.toMillis() &&
          dateStart.toMillis() < currentEventEnd.toMillis()) ||
        (dateEnd.toMillis() > currentEventStart.toMillis() &&
          dateEnd.toMillis() <= currentEventEnd.toMillis())
      ) {
        return event;
      }
    });
    if (exit) {
      return;
    }
    const event = {
      start: dateStart.toString(),
      end: dateEnd.toString(),
      id: this.general.getRandomId(10),
    };

    calendarApi?.addEvent(event);

    this.form3.controls.scheedule_days.updateValueAndValidity();
  }

  handleEventClick(args: any) {
    this.lastEventClicked = args.event;

    const removeDialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'sure-remove-availability',
      },
      autoFocus: false,
    });

    const subscribed = removeDialogRef.afterClosed().subscribe((response) => {
      subscribed.unsubscribe();
      if (!response) {
        return;
      }
      this.removeLastEventClicked();
    });
  }

  handleAllowEventSize(args: any) {
    const calendarApi = this.calendarComponent?.getApi();

    const timezone: any = calendarApi?.getOption('timeZone');
    let start = DateTime.fromISO(args.startStr).setZone(timezone);
    let end = DateTime.fromISO(args.endStr).setZone(timezone);

    let diff = Math.abs(end.diff(start).milliseconds);
    let diff2 = (diff + 1000 * 60) / (1000 * 3600);
    diff = diff / (1000 * 3600);

    let isIntegerDiff = Number.isInteger(diff) || Number.isInteger(diff2);
    if (
      (start.toLocaleString() === end.toLocaleString() ||
        start.toLocaleString() ===
          end.minus({ minutes: 1 }).toLocaleString()) &&
      isIntegerDiff
    ) {
      return true;
    } else {
      return false;
    }
  }
  removeLastEventClicked() {
    if (this.lastEventClicked !== null) {
      this.lastEventClicked.remove();
      this.lastEventClicked = null;
    }
    this.form3.controls.scheedule_days.updateValueAndValidity();
  }

  /**
   * =================== Functions ===================
   */
  intializeSubscriptions() {
    this.subscriptions = [
      this.route.queryParams.subscribe((data) => {
        if (data.lead) {
          this.lead = data.lead;
        }
      }),
      this.form2.controls.country.valueChanges.subscribe(async (data) => {
        try {
          if (
            !(typeof data === 'object' && !Array.isArray(data) && data !== null)
          ) {
            return;
          }

          const response = await this.general.httpGet('cities', {
            country_id: data.id,
          });
          this.form2.controls.city.patchValue('');

          this.cities = response.data;
        } catch (error) {
          console.log(error);
        }
      }),
    ];
  }

  /**
   * Register teacher
   */
  async registerTeacher(stepper: any) {

    try {

      this.loading = true;

      const validated = await this.validateForms();

      if (validated > -1) {
        
        stepper.selectedIndex = validated;
        return;
      }

      if (this.lastPostSended === 1) {
        await this.sendForm2();
        await this.general.sleep(200);
        this.lastPostSended = 2;
      }

      if (this.lastPostSended === 2) {
        await this.sendForm3();
        await this.general.sleep(200);
        this.lastPostSended = 3;
      }
      await this.sendForm4();
      await this.general.sleep(200);
      await this.general.showSuccess('teacher-successfully-registered');
      await this.general.navigate(`/teacher/dashboard`);

    } catch (error) {
      await this.general.showErrorForm(error);
    } finally {
      this.loading = false;
    }
  }

  /**
   * Validate Forms, return -1 | number of current invalid step
   * @returns
   */
  async validateForms() {

    // Validate Form2
    if (this.form2.invalid) {
      this.form2.markAllAsTouched();
      return 0;
    }

    // Validate Form3
    if (this.form3.invalid) {
      this.form3.markAllAsTouched();
      return 1;
    }

    // Validate Form4
    if (this.form4.invalid) {
      this.form4.markAllAsTouched();
      return 2;
    }

    return -1;
  }

  async sendForm2() {
    const formData: any = new FormData();
    formData.append('country_id', this.form2.value.country.id);
    if (typeof this.form2.value.city === 'object') {
      formData.append('city_id', this.form2.value.city.id);
    } else {
      formData.append('custom_city_name', this.form2.value.city);
    }
    formData.append('phone', this.form2.value.phone);
    formData.append('dni', this.form2.value.dni);
    formData.append('gender', this.form2.value.gender);
    formData.append(
      'birthday',
      moment(this.form2.value.birthday).format('YYYY-MM-DD')
    );
    formData.append('languages', JSON.stringify(this.form2.value.languages));
    if (this.form2.value.photo) {
      formData.append('profile_photo_path', this.form2.value.photo);
    }
    formData.append('dni_front', this.form2.value.dni_front);

    let response = await this.general.httpPost('register-teacher-second',formData);
  }

  async sendForm3() {
    let scheedule: any = [];

    let calendarApi = this.calendarComponent?.getApi();
    let events = calendarApi?.getEvents();

    events?.forEach((event) => {
      let day_index = event.start?.getDay();
      let scheeduleDay = scheedule.find(
        (scheDay: any) => scheDay.day_index === day_index
      );
      if (scheeduleDay) {
        scheeduleDay.start_hours.push(moment(event.start).format('HH:mm'));
        scheeduleDay.end_hours.push(moment(event.end).format('HH:mm'));
      } else {
        scheeduleDay = {
          day_index: day_index,
          start_hours: [moment(event.start).format('HH:mm')],
          end_hours: [moment(event.end).format('HH:mm')],
        };
        scheedule.push(scheeduleDay);
      }
    });

    const formData: FormData = new FormData();
    formData.append('description', this.form3.value.description);
    formData.append('goal_joining', this.form3.value.goal_joining);
    if (this.form3.value.other_goal_joining) {
      formData.append(
        'other_goal_joining',
        this.form3.value.other_goal_joining
      );
    }
    formData.append('educational_level', this.form3.value.educational_level);
    formData.append('dedication_time', this.form3.value.dedication_time);

    const timezone = this.general.getCurrentTimezone();

    formData.append(
      'schedule',
      JSON.stringify({ schedule: scheedule, timezone })
    );

    let response = await this.general.httpPost('register-teacher-third', formData);
  }

  async sendForm4() {

    const formData: FormData = new FormData();
    // Subjects
    let subjects: any = [];

    this.form4.value.subjects.forEach((subject: any) => {
      if (
        subject.study_lesson.id ||
        subject.lesson_level_id.length ||
        subject.name || subject.price_hour_single
      ) {
        if (subject.study_lesson.id) {
          subjects.push({
            lesson_level_id: subject.lesson_level_id
              ? subject.lesson_level_id
              : null,
            study_lesson_id: subject.study_lesson.id,
            name: subject.name ? subject.name : null,
            price_hour_single: subject.price_hour_single,
          });
        } else {
          subjects.push({
            lesson_level_id: subject.lesson_level_id
              ? subject.lesson_level_id
              : null,
            study_lesson_id: -1,
            name: subject.name ? subject.name : null,
            price_hour_single: subject.price_hour_single,
          });
        }
      }
    });
    this.form4.value.languages.forEach((subject: any) => {
      if (
        subject.study_lesson.id ||
        subject.lesson_level_id.length ||
        subject.name || subject.price_hour_single
      ) {
        if (subject.study_lesson.id) {
          subjects.push({
            lesson_level_id: subject.lesson_level_id
              ? subject.lesson_level_id
              : null,
            study_lesson_id: subject.study_lesson.id,
            name: subject.name ? subject.name : null,
            price_hour_single: subject.price_hour_single,
          });
        } else {
          subjects.push({
            lesson_level_id: subject.lesson_level_id
              ? subject.lesson_level_id
              : null,
            study_lesson_id: -2,
            name: subject.name ? subject.name : null,
            price_hour_single: subject.price_hour_single,
          });
        }
      }
    });


    this.form4.value.other_activities.forEach((subject: any) => {

      if ( subject.study_lesson.id || subject.name || subject.price_hour_single) {
        if (subject.study_lesson.id) {
          subjects.push({
            lesson_level_id: null,
            study_lesson_id: subject.study_lesson.id,
            name: subject.name ? subject.name : null,
            price_hour_single: subject.price_hour_single,
          });
        } else {
          subjects.push({
            lesson_level_id: null,
            study_lesson_id: -3,
            name: subject.name ? subject.name : null,
            price_hour_single: subject.price_hour_single,
          });
        }
      }
    });

    // this.form4.value.other_activities.forEach((subject: any) => {
    //   if (subject.name) {
    //     subjects.push({
    //       lesson_level_id: null,
    //       study_lesson_id: -3,
    //       name: subject.name,
    //       price_hour_single: subject.price_hour_single,
    //     });
    //   }
    // });






    if (!subjects.length) {
      await this.general.showDanger('one-subject-is-required');
      return;
    }

    formData.append('lessons_and_levels', JSON.stringify(subjects));
    formData.append('certificates', JSON.stringify(this.form4.value.certificates));

    let response = await this.general.httpPost('register-teacher-fourth',formData);
  }

  /**
   * =================== Form 4 ===================
   */

  onChangeStudyLesson(event: any, subject: any) {
    subject.patchValue({
      lesson_level_id: [],
    });
  }

  get validateFormSubjects() {
    return (formGroup: FormGroup) => {
      let res = null;

      if (formGroup.errors && !formGroup.errors.badOrder) {
        // return if another validator has already found an error on the matchingControl
        return;
      }
      const lessonControl = formGroup.controls['study_lesson'];
      const levelControl = formGroup.controls['lesson_level_id'];
      const nameControl = formGroup.controls['name'];
      const price_hour_singleControl = formGroup.controls['price_hour_single'];

      // No validate if all is blank
      if (lessonControl && levelControl && nameControl && price_hour_singleControl) {
        // Subjects and languages
        if (
          !lessonControl.value &&
          !nameControl.value &&
          !price_hour_singleControl.value &&
          !levelControl.value.length
        ) {
          lessonControl.setErrors(res);
          levelControl.setErrors(res);
          nameControl.setErrors(res);
          price_hour_singleControl.setErrors(res);
          return;
        }
      
      } else {

        // Other activities
        if (!nameControl.value || !price_hour_singleControl.value) {
          nameControl.setErrors(res);
          price_hour_singleControl.setErrors(res);
          return;
        }
        
      }

      // Validate if some input is filled
      if (lessonControl && levelControl) {
        // Subjects and languages
        if (
          !(
            (lessonControl.value || nameControl.value && price_hour_singleControl) &&
            levelControl.value.length || price_hour_singleControl.value
          )
        ) {
          res = { required: true };

          if (!lessonControl.value) {
            lessonControl.setErrors(res);
          }
          if (!levelControl.value.length) {
            levelControl.setErrors(res);
          }
          if (!nameControl.value) {
            nameControl.setErrors(res);
          }
          if (!price_hour_singleControl.value.length) {
            price_hour_singleControl.setErrors(res);
          }
        }
      } else {
        if (!nameControl.value) {
          res = { required: true };
          nameControl.setErrors(res);
          return;
        }
      }

      if (res) {
        return;
      }

      if (lessonControl) lessonControl.setErrors(res);
      if (levelControl) levelControl.setErrors(res);
      if (nameControl) nameControl.setErrors(res);
      if (price_hour_singleControl) price_hour_singleControl.setErrors(res);
    };
  }

  validateStudyYears() {
    return (formGroup: FormGroup) => {
      let res = null;

      if (formGroup.errors && !formGroup.errors.badOrder) {
        // return if another validator has already found an error on the matchingControl
        return;
      }
      const yearsControl = formGroup.controls['study_years'];

      if (
        !yearsControl.value ||
        !/^[1-9]\d{3}-[1-9]\d{3}$/g.test(yearsControl.value)
      ) {
        res = { badregx: true };
        yearsControl.setErrors(res);
        return;
      }
      if (
        parseInt(yearsControl.value.split('-')[0]) > new Date().getFullYear() ||
        parseInt(yearsControl.value.split('-')[1]) > new Date().getFullYear() ||
        parseInt(yearsControl.value.split('-')[0]) >
          parseInt(yearsControl.value.split('-')[1])
      ) {
        res = { bad: true };
        yearsControl.setErrors(res);
        return;
      }

      yearsControl.setErrors(res);
    };
  }

  get certificatesFormArray(): any {
    return this.form4.get('certificates') as FormArray;
  }

  addCertificate(): void {
    this.certificatesFormArray.push(
      this.formBuilder.group(
        {
          type: ['', [Validators.required]],
          issued_by: ['', [Validators.required]],
          study_years: ['', [Validators.required]],
          document_base64: ['', [Validators.required]],
          document: ['', [Validators.required]],
          id_image: [this.general.getRandomId(5)],
        },
        {
          validators: this.validateStudyYears(),
        }
      )
    );
  }

  removeCertificate(index: any): void {
    this.certificatesFormArray.removeAt(index);
  }

  onSelectCertificate(event: any, index: any, idImage: any) {
    if (event.files.item(0)) {
      const file = event.files.item(0);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const body: any = {};
        body['document_base64'] = reader.result;
        body['document'] = file;
        this.certificatesFormArray.controls[index].patchValue(body);

        if (file.type.includes('image/')) {
          setTimeout(() => {
            const $source: any = document.getElementById(
              'certificate-' + idImage
            );
            $source.setAttribute(
              'src',
              this.certificatesFormArray.controls[index].value.document_base64
            );
          }, 200);
        }
      };
    }
  }

  get subjectsFormArray(): any {
    return this.form4.get('subjects') as FormArray;
  }

  addSubject(): void {
    this.subjectsFormArray.push(
      this.formBuilder.group(
        {
          study_lesson: [''],
          lesson_level_id: [[]],
          name: [''],
          price_hour_single: [''],
        },
        { validators: [this.validateFormSubjects] }
      )
    );
  }

  removeSubject(index: any): void {
    this.subjectsFormArray.removeAt(index);

    if (!this.subjectsFormArray.value.length) {
      this.addSubject();
    }
  }

  get subjectsLangFormArray(): any {
    return this.form4.get('languages') as FormArray;
  }

  addSubjectLang(): void {
    this.subjectsLangFormArray.push(
      this.formBuilder.group(
        {
          study_lesson: [''],
          lesson_level_id: [[]],
          name: [''],
          price_hour_single: [''],
        },
        { validators: [this.validateFormSubjects] }
      )
    );
  }

  removeSubjectLang(index: any): void {
    this.subjectsLangFormArray.removeAt(index);

    if (!this.subjectsLangFormArray.value.length) {
      this.addSubjectLang();
    }
  }
  get subjectsOtherActivityFormArray(): any {
    return this.form4.get('other_activities') as FormArray;
  }

  addSubjectOtherActivity(): void {
    this.subjectsOtherActivityFormArray.push(
      this.formBuilder.group(
        {
          study_lesson: [''],
          name: [''],
          price_hour_single: [''],
        },
        { validators: [this.validateFormSubjects] }
      )
    );
  }

  removeSubjectOtherActivity(index: any): void {
    this.subjectsOtherActivityFormArray.removeAt(index);

    if (!this.subjectsOtherActivityFormArray.value.length) {
      this.addSubjectOtherActivity();
    }
  }

  get validateForm4() {
    return this.form4.valid;
  }

  /**
   * =================== Scheedule Form 3 ===================
   */
  get scheeduleFormArray(): any {
    return this.form3.get('scheedule') as FormArray;
  }

  getHoursFromScheedule(index: any): any {
    let scheeduleControls = this.scheeduleFormArray.controls[
      index
    ] as FormGroup;
    return scheeduleControls.controls.hours as FormArray;
  }

  addDay(index: Number): void {
    this.scheeduleFormArray.push(
      this.formBuilder.group(
        {
          day_index: [index, [Validators.required]],
          hours: this.formBuilder.array(
            [
              this.formBuilder.group(
                {
                  start_hour: [null, [Validators.required]],
                  end_hour: [null, [Validators.required]],
                },
                { validators: this.checkHours('start_hour', 'end_hour') }
              ),
            ],
            [Validators.required, Validators.minLength(1)]
          ),
        },
        { validators: this.checkHoursArray('hours') }
      )
    );
  }

  removeDay(index: any): void {
    this.scheeduleFormArray.removeAt(index);
  }
  addHour(index: Number): void {
    let hours = this.getHoursFromScheedule(index);
    hours.push(
      this.formBuilder.group(
        {
          start_hour: [null, [Validators.required]],
          end_hour: [null, [Validators.required]],
        },
        { validators: this.checkHours('start_hour', 'end_hour') }
      )
    );
  }

  removeHour(index: any, index2: any): void {
    let hours = this.getHoursFromScheedule(index);
    hours.removeAt(index2);
  }

  /**
   * =================== Validations Form 3===================
   */
  checkHoursArray(controlName: string) {
    return (formGroup: FormGroup) => {
      let res = null;

      if (formGroup.errors && !formGroup.errors.badOrder) {
        // return if another validator has already found an error on the matchingControl
        return;
      }

      const formArray: any = formGroup.controls[controlName];

      if (!formArray.controls.length) {
        formArray.setErrors({ minLength: true });
      }

      formArray.controls.forEach((control: any, index: number) => {
        if (index > 0) {
          if (
            control.value.start_hour &&
            formArray.controls[index - 1].value.end_hour
          ) {
            var startTimeObject = new Date();
            startTimeObject.setHours(
              control.value.start_hour?.split(':')[0],
              control.value.start_hour?.split(':')[1],
              0
            );

            var startOldTimeObject = new Date(startTimeObject);
            startOldTimeObject.setHours(
              formArray.controls[index - 1].value.start_hour?.split(':')[0],
              formArray.controls[index - 1].value.start_hour?.split(':')[1],
              0
            );

            var endOldTimeObject = new Date(startTimeObject);
            endOldTimeObject.setHours(
              formArray.controls[index - 1].value.end_hour?.split(':')[0],
              formArray.controls[index - 1].value.end_hour?.split(':')[1],
              0
            );

            if (
              endOldTimeObject >= startTimeObject ||
              startOldTimeObject >= startTimeObject
            ) {
              res = { badOrder: true };
            }
          }
        }
      });
    };
  }

  checkHours(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors.endBeforeAfter) {
        // return if another validator has already found an error on the matchingControl
        return;
      }
      var startTimeObject = new Date();
      startTimeObject.setHours(
        control.value?.split(':')[0],
        control.value?.split(':')[1],
        0
      );
      var endTimeObject = new Date(startTimeObject);
      endTimeObject.setHours(
        matchingControl.value?.split(':')[0],
        matchingControl.value?.split(':')[1],
        0
      );

      // set error on matchingControl if validation fails
      if (startTimeObject >= endTimeObject) {
        matchingControl.setErrors({ endBeforeAfter: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }

  get invalidScheduleDays() {
    return (
      this.form3.get('scheedule_days')?.invalid &&
      this.form3.get('scheedule_days')?.touched
    );
  }

  get invalidDescription() {
    return (
      this.form3.get('description')?.invalid &&
      this.form3.get('description')?.touched
    );
  }
  get invalidDedicationTime() {
    return (
      this.form3.get('dedication_time')?.invalid &&
      this.form3.get('dedication_time')?.touched
    );
  }
  get invalidEducationalLevel() {
    return (
      this.form3.get('educational_level')?.invalid &&
      this.form3.get('educational_level')?.touched
    );
  }
  get invalidGoalJoining() {
    return (
      this.form3.get('goal_joining')?.invalid &&
      this.form3.get('goal_joining')?.touched
    );
  }
  get invalidOtherGoalJoining() {
    return (
      this.form3.get('other_goal_joining')?.invalid &&
      this.form3.get('other_goal_joining')?.touched
    );
  }
  get validateForm3() {
    return (
      this.form3.valid &&
      (this.form3.value.goal_joining === '5'
        ? this.form3.value.other_goal_joining
        : true)
    );
  }
  get validateForm3Scheedule() {
    return (formGroup: FormGroup) => {
      let calendarApi = this.calendarComponent?.getApi();
      let events = calendarApi?.getEvents();
      if (events && events.length) {
        formGroup.controls.scheedule_days.setErrors(null);
      } else {
        formGroup.controls.scheedule_days.setErrors({ required: true });
      }
    };
  }

  /**
   * =================== Validations Form 2===================
   */
  get birthdayNoValido() {
    return (
      this.form2.get('birthday')?.invalid && this.form2.get('birthday')?.touched
    );
  }
  get dniNoValido() {
    return this.form2.get('dni')?.invalid && this.form2.get('dni')?.touched;
  }
  get phoneNoValido() {
    return this.form2.get('phone')?.invalid && this.form2.get('phone')?.touched;
  }
  get genderNoValido() {
    return (
      this.form2.get('gender')?.invalid && this.form2.get('gender')?.touched
    );
  }
  get invalidCity() {
    return (
      this.form2.controls.city?.invalid && this.form2.controls.city?.touched
    );
  }
  get validateForm2() {
    return this.form2.valid;
  }

  onSelectFile(event: any, atr: any) {
    if (event.files.item(0)) {
      const body: any = {};
      body[atr] = event.files.item(0);
      this.form2.patchValue(body);
      if (this.form2.value[atr].type.includes('image/')) {
        setTimeout(() => {
          const $source: any = document.getElementById(atr);
          $source.setAttribute(
            'src',
            URL.createObjectURL(this.form2.value[atr])
          );
        }, 200);
      }
    }
  }
  validateCountryAndCity() {
    return (formGroup: FormGroup) => {
      let res = null;

      // return if another validator has already found an error on the matchingControl
      if (formGroup.errors && !formGroup.errors.badOrder) {
        return;
      }

      const countryControl = formGroup.controls['country'];
      const cityControl = formGroup.controls['city'];

      if (typeof countryControl.value !== 'object') {
        countryControl.setErrors({ notObject: true });
      }

      if (!cityControl.value) {
        cityControl.setErrors({ notObject: true });
      }
    };
  }

  /**
   * =================== Languages Form 2 ===================
   */
  get languagesFormArray(): any {
    return this.form2.get('languages') as FormArray;
  }

  addLanguage(): void {
    this.languagesFormArray.push(
      this.formBuilder.group({
        language_id: ['', [Validators.required]],
        level_id: ['', [Validators.required]],
      })
    );
  }

  removeLanguage(index: any): void {
    this.languagesFormArray.removeAt(index);
  }

  /**
   * =================== Languages Form 2 ===================
   */
  openPhotoAdvicesDialog() {
    const paymentDialogRef = this.dialog.open(
      TeacherImageAdvicesDialogComponent,
      {
        autoFocus: false,
      }
    );
    const subscribed = paymentDialogRef
      .afterClosed()
      .subscribe(async (data: any) => {
        subscribed.unsubscribe();
      });
  }
}
